var _effectorFileName = "/src/shared/components/animation/reveal/reveal.tsx";
import { useEffect, useRef } from 'react';
import { motion, useAnimation, useInView } from 'framer-motion';
interface RevealAnimationProps {
  children: JSX.Element;
  className?: string;
  delay?: number;
}
export const RevealAnimation = (props: RevealAnimationProps) => {
  const {
    children,
    className,
    delay = 0.1
  } = props;
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true
  });
  const mainControls = useAnimation();
  const slideControls = useAnimation();
  useEffect(() => {
    if (isInView) {
      mainControls.start('visible');
      slideControls.start('visible');
    }
  }, [isInView]);
  return <motion.div ref={ref} variants={{
    hidden: {
      opacity: 0,
      y: 75
    },
    visible: {
      opacity: 1,
      y: 0
    }
  }} initial="hidden" animate={mainControls} transition={{
    duration: 0.3,
    delay: delay
  }} className={className}>
      {children}
    </motion.div>;
};